export default __webpack_public_path__ + "static/media/trash.b0b99f90.svg";